import {
    IonContent,
    IonPage,
    useIonViewDidEnter,
    useIonViewDidLeave,
} from '@ionic/react'
import React, { useState } from 'react'
import {
    getWechatQrcode,
    getWechatBotSettings,
    getScanStatus,
    postUserAction,
} from '../service/api/bot'
import Header from '../components/Header'
import Qrcode from 'qrcode'
import './BindWechat.css'
import { useSelector, useDispatch } from 'react-redux'
import { ReduxStore } from '../redux/reducers'
import { BotSettings } from '../model/bot.model'
import { setBotSettingsInfo } from '../redux/actions/settings'
import { useHistory } from 'react-router'
import { WechatBotPage } from '../conf/routePath'
const BindWechat: React.FC = () => {
    const [qrcodeUrl, setQrcodeUrl] = useState('')
    const dispatch = useDispatch()
    const history = useHistory()
    const botSettings = useSelector<ReduxStore, BotSettings | null>(
        (store) => store.settingsInfo
    )
    // const [loadingOptions, setLoadingOptions] = useState<LoadingProps>({
    //     isOpen: false,
    //     message: '登录中...',
    // })
    const [scanStatus, setScanStatus] = useState<number>(-1)
    let refreshBotSettingTimer: any = null
    useIonViewDidEnter(() => {
        postUserAction('wechaty_refresh')
        loadWechatQrcode()
        loadBotSettings()
    })
    useIonViewDidLeave(() => {
        clearTimeout(refreshBotSettingTimer)
    })
    const loadWechatQrcode = async () => {
        try {
            let res = await getWechatQrcode()
            let url = await Qrcode.toDataURL(res.wechaty_qrcode_url)
            setQrcodeUrl(url)
        } catch (error) {
            console.error(error)
        }
    }
    const loadBotSettings = async () => {
        try {
            refreshBotSettingTimer = setTimeout(async () => {
                loadWechatQrcode()
                let result = await getScanStatus()
                setScanStatus(result.status)
                let res = await getWechatBotSettings()
                dispatch(setBotSettingsInfo(res))
                if (!res.is_online) {
                    loadBotSettings()
                } else {
                    localStorage.setItem('BindSuccess', '1')
                    history.replace(WechatBotPage)
                    clearTimeout(refreshBotSettingTimer)
                }
            }, 1000)
        } catch (error) {
            clearTimeout(refreshBotSettingTimer)
            console.error(error)
        }
    }
    const QrcodeComp = () => {
        return (
            <div className='qrcode-wrapper'>
                {qrcodeUrl && <img src={qrcodeUrl} alt='qrcode' />}
            </div>
        )
    }
    return (
        <IonPage>
            <IonContent className='bind-wechat-content'>
                <Header title='绑定机器人' />
                <div className='qrcode-content'>
                    <QrcodeComp />
                    {scanStatus > 2 && (
                        <div className='scan-status'>
                            {scanStatus === 3 && <span>已扫码</span>}
                            {scanStatus === 4 && <span>绑定中...</span>}
                        </div>
                    )}
                </div>
                {/* <p className='tip'>长按保存二维码</p> */}
                {botSettings && !botSettings.is_online && (
                    <p className='offline-tip'>{botSettings.offline_reason}</p>
                )}
                <p className='tip-1'>请用机器人的微信扫码授权绑定</p>
                {/* <p
                    className='product-link'
                    onClick={() => history.push(ProductIntroPage)}
                >
                    详情查看《产品使用手册》->
                </p> */}
            </IonContent>
            {/* <IonLoading {...loadingOptions} /> */}
        </IonPage>
    )
}
export default BindWechat
